import React, { useState } from "react";
import _, { isEmpty } from "lodash";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import { useFormikContext } from "formik";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import { TextField } from "@material-ui/core";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SafeStockItemDetailForm from "./SafeStockItemDetailForm";
function SafeStockFormContent({
  warehouseID = 0,
  outletID = 0,
  onReloadSafeStock,
}) {
  const [selectedData, setSelectedData] = useState({
    ID: 0,
    itemID: 0,
    itemType: 0,
    itemTypeName: "",
    itemCode: "",
    itemName: "",
  });
  const [openItemDetail, setOpenItemDetail] = useState(false);
  const { values, setFieldValue, handleSubmit } = useFormikContext();
  return (
    <React.Fragment>
      <CustomDataTable
        data={values}
        onRefreshData={() => {
          onReloadSafeStock();
        }}
        buttons={[
          {
            name: "Save",
            onClick: (e) => {
              handleSubmit(e);
            },
            icon: "fas fa-save",
            color: "success",
          },
        ]}
        columns={[
          {
            header: "Item ID",
            field: "itemID",
            body: null,
            sortable: true,
            filter: true,
          },
          {
            header: "Item Type",
            field: "itemTypeName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.itemTypeName} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
            filter: true,
            hidden: true,
          },
          {
            header: "Item Code",
            field: "itemCode",
            body: (rowData) => (
              <React.Fragment>
                {rowData.itemType > 0 ? (
                  <span>
                    <BootstrapTooltip title={rowData.itemTypeName}>
                      <span className="mr-2">
                        <i
                          className={
                            rowData.itemType === 1
                              ? "fas fa-boxes text-success"
                              : rowData.itemType === 2
                              ? "fas fa-tools text-primary"
                              : rowData.itemType === 3
                              ? "fas fa-building text-info"
                              : rowData.itemType === 4
                              ? "fas fa-boxes text-warning"
                              : rowData.itemType === 5
                              ? "fas fa-boxes text-danger"
                              : null
                          }
                        ></i>
                      </span>
                    </BootstrapTooltip>
                    <span>
                      <ResponsiveEllipsis
                        text={rowData.itemCode}
                        maxLine="1"
                        displayInline
                      />
                    </span>
                  </span>
                ) : (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.itemCode} maxLine="1" />
                  </React.Fragment>
                )}
              </React.Fragment>
            ),
            sortable: true,
            filter: true,
          },
          {
            header: "Item Name",
            field: "itemName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
            filter: true,
          },
          {
            header: "Base Unit",
            field: "uomName",
            body: null,
            sortable: true,
            filter: true,
          },
          {
            header: "Safety Stock",
            field: "qty",
            body: (rowData, option) => (
              <React.Fragment>
                {rowData.itemVarValue.length === 0 ? (
                  <TextField
                    id={`qty[${option.rowIndex}]`}
                    type="number"
                    fullWidth
                    value={rowData.qty}
                    variant="outlined"
                    size="small"
                    onChange={(e) => {
                      if (isEmpty(e.target.value)) {
                        e.target.value = 0;
                      }
                      e.target.value = parseFloat(e.target.value);
                      const qty = parseFloat(e.target.value);
                      const itemsTmp = [...values];
                      const index = _.findIndex(itemsTmp, (item) => {
                        return item.itemID === rowData.itemID;
                      });
                      itemsTmp[index].qty = qty;
                      setFieldValue(itemsTmp);
                    }}
                  />
                ) : null}
              </React.Fragment>
            ),
            sortable: true,
            filter: true,
          },
          {
            header: "Request Quantity",
            field: "requestQty",
            body: (rowData, option) => (
              <React.Fragment>
                {rowData.itemVarValue.length === 0 ? (
                  <TextField
                    id={`requestQty[${option.rowIndex}]`}
                    type="number"
                    fullWidth
                    value={rowData.requestQty}
                    variant="outlined"
                    size="small"
                    onChange={(e) => {
                      if (isEmpty(e.target.value)) {
                        e.target.value = 0;
                      }
                      e.target.value = parseFloat(e.target.value);
                      const qty = parseFloat(e.target.value);
                      const itemsTmp = [...values];
                      const index = _.findIndex(itemsTmp, (item) => {
                        return item.itemID === rowData.itemID;
                      });
                      itemsTmp[index].requestQty = qty;
                      setFieldValue(itemsTmp);
                    }}
                  />
                ) : null}
              </React.Fragment>
            ),
            sortable: true,
            filter: true,
          },
          {
            header: "Actions",
            body: (rowData) => (
              <React.Fragment>
                {rowData.ID > 0 ? (
                  <BootstrapTooltip title="Safe Stock Item Detail">
                    <button
                      type="button"
                      onClick={() => {
                        setSelectedData(rowData);
                        setOpenItemDetail(true);
                      }}
                      className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                    >
                      <i className="fas fa-list-alt"></i>
                    </button>
                  </BootstrapTooltip>
                ) : null}
              </React.Fragment>
            ),
            sortable: false,
          },
        ]}
      />
      <DialogLayout
        open={openItemDetail}
        title={`Safe Stock Detail Item - ${selectedData.itemCode} ${selectedData.itemName}`}
        onCloseDialog={() => {
          setOpenItemDetail(false);
        }}
        maxWIdth="md"
      >
        <SafeStockItemDetailForm
          safeStockID={selectedData.ID}
          warehouseID={warehouseID}
          outletID={outletID}
          item={selectedData}
          onCloseDialog={() => {
            setOpenItemDetail(false);
          }}
          onConfirmSave={() => {
            setOpenItemDetail(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );
}

export default SafeStockFormContent;
